import { DEFAULT_GROUP_KEY, lookupMessage, gracefullyLookupMessage } from "../i18n/dictionary.js";
import { TLMD_SCHEMA_BASE_URI_PATH } from "../schemas/schemas.js";
import { parse } from 'uri-js';
const toMessage = (valueOrPath, dictionary, defaultGroupKey = DEFAULT_GROUP_KEY) => {
    if (typeof valueOrPath === 'string') {
        const pathSegments = valueOrPath.substring(valueOrPath.startsWith('/') ? 1 : 0).split('/');
        const msg = lookupMessage(pathSegments, dictionary, defaultGroupKey);
        return msg ? msg : valueOrPath;
    }
    else {
        return valueOrPath ? JSON.stringify(valueOrPath) : undefined;
    }
};
export const getErrorMessage = (error, schema, errorDictionary, ignore = TLMD_SCHEMA_BASE_URI_PATH) => {
    let schemaPath = error.schemaPath.startsWith('#')
        ? `${schema.$id ? parse(schema.$id).path : ''}${error.schemaPath.substring(1)}`
        : error.schemaPath.startsWith('https://') ? parse(error.schemaPath).path : error.schemaPath;
    if (ignore) {
        schemaPath = schemaPath.startsWith(ignore) ? schemaPath.substring(ignore.length) : schemaPath;
    }
    if (error.keyword === 'errorMessage' && error.message) {
        return error.message;
    }
    else {
        const pathSegments = schemaPath.substring(schemaPath.startsWith('/') ? 1 : 0).split('/');
        const msg = gracefullyLookupMessage(pathSegments, errorDictionary);
        if (msg) {
            if (error.params) {
                return Object.keys(error.params).reduce((message, paramKey) => {
                    const paramValue = error.params[paramKey];
                    const readableValue = paramValue.pop
                        ? paramValue.map((v) => toMessage(v, errorDictionary)).join(', ')
                        : toMessage(paramValue, errorDictionary);
                    return message.replace(new RegExp(`{${paramKey}}`, "g"), readableValue);
                }, msg);
            }
            else {
                return msg;
            }
        }
        else {
            if (error.message) {
                return error.message;
            }
            else {
                return 'error';
            }
        }
    }
};
// //to keep compile quite use this decorator instead of JSONSchema so we can pass ajv-error  errorMessage properties in the schema
// export const JSONSchemaAjvError = (schema: DecoratorSchema & { errorMessage?: any }) => {
//     return JSONSchema(schema);
// };
export const extractErrorMessages = (errors, schema, dictionary) => {
    if (errors) {
        return errors.reduce((map, error) => {
            const key = error.instancePath.split('/')[1];
            const msg = getErrorMessage(error, schema, dictionary);
            if (map[key]) {
                map[key].push(msg);
            }
            else {
                map[key] = [msg];
            }
            return map;
        }, {});
    }
    else {
        return {};
    }
};
